import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { Code } from 'components/Code';
import { FilePickerProvider } from 'components/FilePickerProvider';
import { emitMessage } from 'engine/api';
import { SkinForm } from 'forms/GameSkinForm';
import { X } from 'lucide-react';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { GameSkinSchema, type GameSkin, type SkinRecord } from 'shared/modelTypes/skin';
import { toast } from 'sonner';

export const Route = createFileRoute('/dashboard/skins/edit/$id')({
	component: RouteComponent,
	loader: async ({ params }) => {
		const skin = await emitMessage({ kind: 'skin-find', id: params.id });
		return {
			skin,
			directory: (await emitMessage({ kind: 'media-list-directory', folderId: null })).media,
		};
	},
});

function RouteComponent() {
	const data = Route.useLoaderData();

	if (!data.skin.skin) {
		return <div>skin not found</div>;
	}

	return (
		<div>
			<FilePickerProvider startDirectory={data.directory!}>
				<SkinEditForm skin={data.skin.skin} />
			</FilePickerProvider>
		</div>
	);
}

function SkinEditForm({ skin }: { skin: SkinRecord }) {
	const router = useRouter();

	const methods = useForm<GameSkin>({
		// @ts-expect-error zodResolver type inference seems to be bad
		resolver: zodResolver(GameSkinSchema),
		defaultValues: skin.skin,
	});

	const err = methods.formState.errors;

	const [result, setResult] = useState<GameSkin | undefined>();
	const [_res, setRes] = useState<Promise<unknown> | undefined>();

	const onSubmit = async (data: GameSkin) => {
		setResult(data);

		const r = emitMessage({
			kind: 'skin-update',
			skin: {
				id: skin.id,
				skin: data,
			},
		});
		setRes(r);
		const response = await r;
		if (response.success) {
			router.invalidate();
			router.navigate({ to: '/dashboard/skins' });
		} else {
			setRes(undefined);
			toast('server did not save skin', { icon: <X /> });
		}
	};

	console.log(err);

	return (
		<FormProvider {...methods}>
			<form
				className="flex flex-col gap-3"
				// @ts-expect-error zodResolver type inference seems to be bad
				onSubmit={methods.handleSubmit(onSubmit)}
			>
				<SkinForm label="Edit Skin" />
				<Button type="submit">Save skin</Button>
			</form>
			{result && (
				<Code block className="mt-4">
					{JSON.stringify(result, null, 2)}
				</Code>
			)}
		</FormProvider>
	);
}
